<template>
  <ls-table-layout>
    <template #search>
      <inbound-execution-report-search @search="onSearch" />
    </template>
    <template #btn>
      <a-button v-hasPermi="['inboundExecutionReport:export']" @click="onExport">导出</a-button>
    </template>
    <template #table>
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :scroll="{ x: 1000, fixScreen: true}"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.INBOUND_EXECUTION_REPORT_LIST, // 表格方案配置唯一值
              }"
      >
        <!--        分仓调度-->
        <template #planType="{text, record}">
          <span class="cursor-pointer" @click="onJumpRouter(record)">{{ record.planTypeName }}</span>
        </template>
        <template #errorRate="{text}">
          {{ getPercent(text) }}
        </template>
      </ls-api-table>
      <DownloadModal :api-fun="apiExportInventoryExecutionReportList" ref="download" ></DownloadModal>
    </template>
  </ls-table-layout>
</template>
<script>

import { generateLsTableResData } from '@/utils/util'
import {
  apiExportInventoryExecutionReportList,
  apiInventoryExecutionReportList
} from '@/api/mes/scheduling-plan/master-control-plan'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import InboundExecutionReportSearch
  from '@/views/mes/scheduling-plan/inbound-execution-repor/components/inbound-execution-report-search.vue'
import moment from 'moment/moment'

export default {
  // eslint-disable-next-line
  name: 'Inbound-execution-report-list', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { InboundExecutionReportSearch, DownloadModal },
  data () {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: "reportIndex",
          customRender: (text, record, index) => {
            return index + 1;
          }
        },
        {
          title: '物料编码',
          width: 150,
          dataIndex: 'materialNo',
          scopedSlots: { customRender: 'materialNo' }
        },
        {
          title: '物料名称',
          width: 100,
          dataIndex: 'materialName',
          scopedSlots: { customRender: 'materialName' }
        },
        {
          title: '规格描述',
          width: 150,
          dataIndex: 'materialSpec',
          ellipsis: true,
          scopedSlots: { customRender: 'materialSpec' }
        },
        {
          title: '要求到仓日期',
          width: 120,
          dataIndex: 'requireDeliveryDay',
          scopedSlots: { customRender: 'requireDeliveryDay' }
        },
        {
          title: '计划到仓数量',
          dataIndex: 'originalRequireDeliveryQuantity',
          width: 150,
          scopedSlots: { customRender: 'originalRequireDeliveryQuantity' }
        },
        {
          title: '已安排数量',
          width: 100,
          dataIndex: 'arrangeQuantity',
          scopedSlots: { customRender: 'arrangeQuantity' }
        },
        {
          title: '取消数量',
          width: 100,
          dataIndex: 'cancelQuantity',
          scopedSlots: { customRender: 'cancelQuantity' }
        },
        {
          title: '未安排数量',
          width: 100,
          dataIndex: 'noArrangeQuantity',
          scopedSlots: { customRender: 'noArrangeQuantity' }
        },
        {
          title: '装车数量',
          width: 100,
          dataIndex: 'entruckQuantity',
          scopedSlots: { customRender: 'entruckQuantity' }
        },
        {
          title: '已入库数量',
          width: 100,
          dataIndex: 'inStockQuantity',
          scopedSlots: { customRender: 'inStockQuantity' }
        },
        {
          title: '异常率',
          width: 100,
          dataIndex: 'errorRate',
          scopedSlots: { customRender: 'errorRate' }
        },
        {
          title: '调度分类',
          width: 120,
          dataIndex: 'planType',
          scopedSlots: { customRender: 'planType' }
        },
        {
          title: '入库仓',
          width: 100,
          dataIndex: 'warehouseName',
          scopedSlots: { customRender: 'warehouseName' }
        },
        {
          title: '完成状态',
          width: 100,
          dataIndex: 'statusName',
          scopedSlots: { customRender: 'statusName' }
        }
      ],
      tableProps: {
        requestApi: generateLsTableResData(apiInventoryExecutionReportList, false)
      }
    }
  },
  methods: {
    apiExportInventoryExecutionReportList,
    onJumpRouter (record) {
      // 1: '分仓计划', 2: '调拨计划', 3: '外部计划', 4: '调拨计划-卫星仓
      console.log(record.planType)
      switch (record.planType) {
        case "1":
          this.$router.push({
            name: 'Warehouse-allocation-plan',
            query: {
              materialNo: record.materialNo,
              deliveryDate: record.requireDeliveryDay,
              warehouseCode: record.warehouseCode,
              version: record.version
            }
          })
          break;
        case "2":
        case "4":
          this.$router.push({
            name: 'Allocation-plan',
            query: {
              materialNo: record.materialNo,
              deliveryDate: record.requireDeliveryDay,
              warehouseCode: record.warehouseCode,
              planType: record.planType
            }
          })
          break;
        case "3":
          this.$router.push({
            name: 'Receiving-plan',
            query: {
              billNo: record.billNos
            }
          })
          this.$EventBus.$emit('receiving-plan-search')
          break;
      }
    },
    // 搜索
    onSearch (val = {}) {
      this.$refs.dataTable.searchParams = {
        ...val,
        requireDeliveryTimeStart: val.requireDeliveryTime?.[0]?.format('YYYY-MM-DD 00:00:00'),
        requireDeliveryTimeEnd: val.requireDeliveryTime?.[1]?.format('YYYY-MM-DD 23:59:59')
      }
      this.$refs.dataTable.getData()
    },
    // 成功回调
    onSuccess() {
      const data = this.$refs.dataTable.searchParams
      this.onSearch(data)
    },
    // 导出
    onExport () {
      const val = this.$refs.dataTable.searchParams || {}
      this.$refs.download.openModal(val)
    },
    // 返回百分比
    getPercent(val) {
      return `${Math.floor(val * 10000) / 100 }%`
    }
  },
  mounted() {
    const requireDeliveryTime = [moment(), moment()]
    this.onSearch({ requireDeliveryTime })
  }
}
</script>
<style lang="less" scoped>
.cursor-pointer{
  cursor: pointer;
  color: #1890ff;
}
::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
  padding: 4px;
}
</style>
